import { authClient, getSession } from "@/auth-client";
import { Button } from "@/components/ui/button";
import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { AlertCircle, LogOut } from "lucide-react";

export const Route = createFileRoute("/(dashboard)/_authenticated/")({
  component: RouteComponent,
  loader: async ({ context }) => {
    const session = await context.queryClient.fetchQuery({
      queryKey: ["session"],
      queryFn: () => getSession(),
    });

    if (!session) {
      throw redirect({ to: "/login" });
    }

    const { user } = session;
    // Redirect to the first company if there are multiple
    if (user.companies.length && user.companies.length > 0) {
      const firstCompany = user.companies[0];

      // Check if user is not admin
      const isMember = !firstCompany.isAdmin;

      if (isMember) {
        // Find the first department where user is a member
        const firstDepartment = user.departments?.find(
          (dept) => dept.companyId === firstCompany.id,
        );

        if (firstDepartment?.id) {
          // Redirect to the department dashboard
          return redirect({
            to: "/$companyId/team/$teamId/dashboard",
            params: {
              companyId: firstCompany.id,
              teamId: firstDepartment.id,
            },
          });
        }
      }

      if (isMember) {
        return;
      }

      // Redirect to company dashboard
      return redirect({
        to: "/$companyId",
        params: { companyId: firstCompany.id },
      });
    }
  },
});

function RouteComponent() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  async function handleSignOut() {
    await authClient.signOut();
    // Clear the query cache
    queryClient.clear();
    navigate({ to: "/login" });
  }

  return (
    <div className="flex flex-col gap-2 h-[calc(100vh-4rem)] items-center justify-center">
      <div className="flex flex-col items-center gap-4 rounded-lg border border-destructive/50 bg-destructive/10 p-6 text-center">
        <AlertCircle className="h-8 w-8 text-destructive" />
        <h2 className="text-lg font-semibold text-destructive">Error</h2>
        <p className="text-sm text-muted-foreground">
          Por favor, contacte con el soporte técnico porque la empresa ya
          debería estar creada y no se puede crear manualmente.
        </p>
      </div>
      <Button onClick={handleSignOut} className="w-fit">
        <LogOut />
        Finalizar la sesión
      </Button>
    </div>
  );
}
